const type = 'advanced'
const path = 'client/react'
const name = 'App.jsx'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath }
